<template>
  <!-- A design-system icon (airlst2027 www/assets/icons, synced to Libraries/design-system-icons.js):
       static SVG markup from the design system, never user data. Decorative; it takes the
       current text colour and the size its class gives it (16px by default). -->
  <!-- eslint-disable vue/no-v-html -->
  <span
    class="inline-flex size-4 flex-none [&>svg]:size-full"
    aria-hidden="true"
    v-html="ICONS[name]"
  />
</template>

<script setup>
import { ICONS } from '@/Libraries/design-system-icons'

defineProps({
  /** The icon's name in the design system (ICON_NAMES). */
  name: {
    type: String,
    required: true,
  },
})
</script>
